module.exports = __webpack_public_path__ + "img/main-logo.74affd38.png";